import React, { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import eventReportAction from "~/actions/reporting/eventReportAction";
import Utils from "~/helpers/Utils";
import PeriodFilter from "~/components/common/periodReport/PeriodFilter";
import reportingAction from "~/actions/reportingAction";
import "~/components/reporting/Reporting.scss";

const EventFilterPeriod = () => {
    const dispatch = useDispatch();
  
    const { requestPeriod } = useSelector((state) => state.app.loading);

    const onFormRefUpdate = useCallback(
        (_periodForm) => {
            dispatch(eventReportAction.updatePeriodForm(_periodForm.current));
        },
        [dispatch]
    );

    return (
        <PeriodFilter
            onFormRefUpdate={onFormRefUpdate}
            loading={requestPeriod}
            onSubmit={(values, { setSubmitting, resetForm }) => {
                dispatch(
                    reportingAction.generateReportingPerPeriod(
                        {
                            RelatorioTipoId: 22,
                            DataInicial: Utils.utcToLocal(values.period.startDate),
                            DataFinal: Utils.utcToLocal(values.period.endDate),
                            Velocidade: values.speed > 0 ? values.speed : null,
                            Email: values.email,
                            ObjetoRastreavelId: values.vehicle ? parseInt(values.vehicle.id) : null,
                            GrupoId: values.fleet ? parseInt(values.fleet.id) : null,
                        },
                        (response) => {
                            dispatch(reportingAction.updateFilterEventLastRecord(response));
                            setSubmitting(false);
                            resetForm();
                            dispatch(
                                reportingAction.updatePaginationPerPeriod({
                                    Start: 0,
                                    Index: 0,
                                    Length: 25,
                                })
                            );
                        }
                    )
                );
            }}
        />
    );
};
export default EventFilterPeriod;
